function isBasic(value) {
    return (typeof value === 'number' && !isNaN(value) && Number.isFinite(value)) ||
        typeof value === 'string' ||
        typeof value === 'boolean';
}
export class FormationMeta {
    constructor(context) {
        for (const [key, value] of Object.entries(context)) {
            if (isBasic(value)) {
                Object.defineProperty(this, key, { value, enumerable: true, writable: true });
            }
            else if (typeof value !== 'object' || value === null) {
                continue;
            }
            else if (typeof value[Symbol.toPrimitive] === 'function') {
                Object.defineProperty(this, key, { value: value[Symbol.toPrimitive](), enumerable: true, writable: true });
            }
            else if (!Array.isArray(value)) {
                Object.defineProperty(this, key, { value: new FormationMeta(value), enumerable: true, writable: true });
            }
            else {
                Object.defineProperty(this, key, { value: value.filter(isBasic), enumerable: true, writable: true });
            }
        }
    }
}
export const klass = FormationMeta;
export { FormationMeta as Meta };
export default FormationMeta;
//# sourceMappingURL=Meta.js.map